import SignIn from './SignInContainer'

export default SignIn



// WEBPACK FOOTER //
// ./src/components/SignIn/index.js